import React, { useEffect } from 'react'
import ProjectCard from '../components/ProjectCard'
import HeImg from '../assets/img/projects/he.jpg'
import SgImg from '../assets/img/projects/sg.png'
import BbImg from '../assets/img/projects/bb.jpg'
import NaImg from '../assets/img/projects/na.png'
import StImg from '../assets/img/projects/st.png'
import SkImg from '../assets/img/projects/sk.png'


const Skills = () => {

    useEffect(() => {
        document.title = 'Arya Rizky Tri Putra - Projects'
    }, []);

    return <section className='text-light container mx-auto pb-32  mt-24 px-5'>
        <h3 className='font-black md:text-3xl text-2xl mb-5 text-center'>My Amazing Projects📝</h3>
        <div className='grid md:grid-cols-3 grid-cols-1 gap-5 mb-10' >
            <ProjectCard img={HeImg} title="HeyEvents!" desc="Website to search, join, and manage various events. Created for the purpose of entering the Dinacom 2022 app development competition." techs={['Laravel', 'Tailwind', 'Firebase']} />
            <ProjectCard img={SgImg} title="SemesterGenap" desc="A website that has the main features for online classes, where users can choose the appropriate package." techs={['HTML', 'Javascript', 'Tailwind']} />
            <ProjectCard img={NaImg} title="Nakula" desc="Simple E-Commerce website for school project." techs={['Javascript', 'Tailwind', 'Firebase']} />
            <ProjectCard img={StImg} title="Sanggar Tari" desc="Website featuring some traditional Indonesian dances." techs={['Javascript', 'Tailwind', 'Firebase']} />
            <ProjectCard img={BbImg} title="BangkitBersama" desc="Mobile application to make it easier for users to share something useful with other user.." techs={['React Native', 'Firebase', 'Play Store']} />
            <ProjectCard img={SkImg} title="SemkanisaKopsis" desc="Mobile application to manage  school cooperative." techs={['React Native', 'Firebase']} />
        </div>
    </section>
}

export default Skills
